import { render } from "./important-wgcl-count.vue?vue&type=template&id=3f7c55aa&scoped=true"
import script from "./important-wgcl-count.vue?vue&type=script&lang=js"
export * from "./important-wgcl-count.vue?vue&type=script&lang=js"

import "./important-wgcl-count.vue?vue&type=style&index=0&id=3f7c55aa&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f7c55aa"]])

export default __exports__